import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

// A new trial doesn't need a countdown: day one is for getting the app installed (#1130).
// Shown from 15 days left; trials extended past 30 days wait the same way.
export const TRIAL_BANNER_FROM_DAYS = 15;

// Trial state is fetched once by AppContent (see checkAccess) and passed down, so the
// page no longer hits /subscriptions/status twice on every authenticated load.
function TrialBanner({ isTrial, daysRemaining }: { isTrial: boolean; daysRemaining: number | null }) {
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('chaptery.trial.banner.dismissed') === '1');
  const location = useLocation();

  if (dismissed || !isTrial || daysRemaining === null) return null;
  if (daysRemaining > TRIAL_BANNER_FROM_DAYS) return null;
  if (location.pathname === '/pricing' || location.pathname === '/tos') return null;

  const handleDismiss = () => {
    sessionStorage.setItem('chaptery.trial.banner.dismissed', '1');
    setDismissed(true);
  };

  return (
    <div className="trial-banner">
      <span>
        <strong>{daysRemaining} day{daysRemaining !== 1 ? 's' : ''} left</strong> in your free trial.{' '}
        <a href="/pricing" className="trial-banner-link">Subscribe to keep going</a>
      </span>
      <button className="trial-banner-dismiss" onClick={handleDismiss} aria-label="Dismiss">✕</button>
    </div>
  );
}

export default TrialBanner;
